import { render, staticRenderFns } from "./veStuHygieneStudentEdit.vue?vue&type=template&id=90a06f1e&scoped=true"
import script from "./veStuHygieneStudentEdit.vue?vue&type=script&lang=js"
export * from "./veStuHygieneStudentEdit.vue?vue&type=script&lang=js"
import style0 from "./veStuHygieneStudentEdit.vue?vue&type=style&index=0&id=90a06f1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a06f1e",
  null
  
)

export default component.exports